export default function Privacy() {
  return (
    <div className="mx-auto p-4 w-screen h-screen bg-white">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="text-base mb-4"><strong>Effective Date:</strong> April 28, 2025</p>

      <p className="text-base mb-4">
        STEM Enrichment of New Jersey ("we," "us," "our") values your privacy. This Privacy Policy explains how we collect, use, and protect your information.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
      <ul className="list-disc list-inside mb-4 space-y-2">
        <li><strong>Cookies and Analytics:</strong> We use cookies and similar technologies to collect information about how visitors use our Site (e.g., pages visited, time spent). We use services like Google Analytics.</li>
        <li><strong>Newsletter Signup:</strong> If you choose to sign up for our newsletter, we collect your email address and manage subscriptions via Mailchimp.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
      <ul className="list-disc list-inside mb-4 space-y-2">
        <li>To operate and maintain our Site</li>
        <li>To understand how users interact with our Site</li>
        <li>To send newsletters (only if you subscribe)</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">3. Sharing Information</h2>
      <p className="text-base mb-4">
        We may share information with trusted third-party services, such as Google Analytics and Mailchimp, solely for the purposes outlined above.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">4. Cookies</h2>
      <p className="text-base mb-4">
        Cookies are small data files stored on your device. You can disable cookies in your browser settings, but parts of our Site may not function properly.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">5. Your Rights</h2>
      <p className="text-base mb-4">
        Depending on your location, you may have the right to access, update, or delete your personal data. Please contact us if you wish to exercise these rights.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">6. Security</h2>
      <p className="text-base mb-4">
        We take reasonable steps to protect your information, but no internet transmission is completely secure.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">7. Changes to this Policy</h2>
      <p className="text-base mb-4">
        We may update this Privacy Policy. Changes will be posted on this page with the effective date.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">8. Contact Us</h2>
      <p className="text-base mb-4">
        For any privacy-related questions, email us at [insert your contact email].
      </p>
    </div>
  );
}
